import React from 'react';
import { FormattedMessage } from 'react-intl';
import randomstring from 'uuid/v4';

import Radio from '@material-ui/core/Radio';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Fab from '@material-ui/core/Fab';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import Contidition from '@material-ui/icons/Code';
import Accion from '@material-ui/icons/SubdirectoryArrowRight';

import ButtonAdd from './ButtonAdd';
import Condition from './Condition';
import Action from './Action';
import { types, getType } from '../../../../const/types.task';

import {
    BlueCloseIcon,
    BlueTickIcon,
    TrashIcon,
    ListIcon,
    TypeTabIcon,
    TypeBooleanIcon,
    TypeActionIcon,
    TypeCalendarIcon,
    TypeCameraIcon,
    TypeCheckBoxIcon,
    TypeDropdownIcon,
    TypeFileIcon,
    TypeMultiCheckIcon,
    TypeNumberRealIcon,
    TypeSignIcon,
    TypeTextFixedIcon,
    TypeTextIcon,
    TypeTempIcon,
    TypeTempAutoIcon,
    TypeTimeIcon,
    DateTimeIcon,
    TypeVenueIcon,
    TypeVideoIcon,
} from '../../../../images/icons/WrapSvg';

const getIcon = (type, style) => {
    switch (getType(type, style)) {
        case types.section:
            return <ListIcon color="primary" />;
        case types.action:
            return <TypeActionIcon color="primary" />;
        case types.date:
            return <TypeCalendarIcon color="primary" />;
        case types.datetime:
            return <DateTimeIcon color="primary" />;
        case types.time:
            return <TypeTimeIcon color="primary" />;
        case types.file:
            return <TypeFileIcon color="primary" />;
        case types.photo:
            return <TypeCameraIcon color="primary" />;
        case types.video:
            return <TypeVideoIcon color="primary" />;
        case types.options:
            return <TypeDropdownIcon color="primary" />;
        case types.multioption:
            return <TypeMultiCheckIcon color="primary" />;
        case types.number:
        case types.real:
            return <TypeNumberRealIcon color="primary" />;
        case types.text:
            return <TypeTextIcon color="primary" />;
        case types.textfixed:
            return <TypeTextFixedIcon color="primary" />;
        case types.signature:
            return <TypeSignIcon color="primary" />;
        case types.checks:
            return <TypeCheckBoxIcon color="primary" />;
        case types.local:
            return <TypeVenueIcon color="primary" />;
        case types.boolean:
            return <TypeBooleanIcon color="primary" />;
        case types.tab:
            return <TypeTabIcon color="primary" />;
        case types.temp:
            return <TypeTempIcon color="primary" />;
        case types.auto:
            return <TypeTempAutoIcon color="primary" />;
        default:
            return <div />;
    }
};

class EditRules extends React.Component {
    state = {
        condicion: [],
        accion: [],
        nombre: '',
        yo: undefined,
        tipo: undefined,
    };

    static getDerivedStateFromProps(props, state) {
        const { rule } = props;
        const { accion, condicion } = rule;
        console.log(accion, state.accion);
        if (rule !== state.rule) {
            state.rule = rule;
            state.condicion = rule && rule.condicion ? rule.condicion : [];
            state.accion = rule && rule.accion ? rule.accion : [];
            state.nombre = rule && rule.nombre ? rule.nombre : '';
            state.tipo = rule && rule.tipo ? rule.tipo.toString() : undefined;
            state.yo = rule && rule.yo ? rule.yo.toString() : '1';
            state.transicion = rule && rule.transicion ? rule.transicion.toString() : undefined;
            return state;
        } else if (condicion !== state.condicion) {
            state.condicion = rule && rule.condicion ? rule.condicion : [];
            return state;
        } else if (accion !== state.accion) {
            state.accion = rule && rule.accion ? rule.accion : [];
            return state;
        }
        return null;
    }


    handleChange = (event) => {
        this.props.onChange(event.target.name, event.target.value);
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChangeType = (event) => {
        let { condicion } = this.state;
        if (event.target.value === "1") {
            condicion = condicion.filter(f => f.tipo.toString() !== "100" && f.tipo.toString() !== "101" && f.tipo.toString() !== "102");
        } else {
            condicion = [{
                tipo: 102,
                parametros: {}
            }];
        }
        this.props.onChange("condicion", condicion);
        this.props.onChange(event.target.name, event.target.value);
        this.setState({ [event.target.name]: event.target.value, condicion: condicion });
    };

    isOkCondition = (condicion) => {
        return condicion.tipo !== undefined &&
            condicion.parametros &&
            (condicion.tipo.toString() === "100" || condicion.tipo.toString() === "101" || condicion.tipo.toString() === "102" || condicion.parametros.campo) &&
            ((condicion.tipo.toString() !== "9" && condicion.tipo.toString() !== "12") || condicion.parametros.valor)
            ;
    }

    isOkAction = (action) => {
        return action.tipo !== undefined &&
            ((action.tipo.toString() === "1" && action.parametros && action.parametros.campo) ||
                (action.tipo.toString() === "2" && action.parametros && action.parametros.tipo && (action.parametros.plantilla || (action.parametros.familia && action.parametros.proceso))))
            ;
    }

    isOk = () => {
        const { tipo, condicion, accion, nombre, transicion } = this.state;
        /*console.log(tipo);
        console.log((tipo === "1" || transicion));
        console.log((tipo === "2" ));
        console.log(condicion);
        console.log((condicion &&
                    condicion.length > 0 &&
                    condicion.reduce((result, item) => { result = result && this.isOkCondition(item); return result } ,true) ) );
        console.log(accion);
        console.log(accion.filter((i) => !tipo || i.tipo.toString() === tipo.toString()).length > 0);
        console.log(accion.filter((i) => !tipo || i.tipo.toString() === tipo.toString()).reduce((result, item) => { result = result && this.isOkAction(item); return result } ,true));
        console.log(nombre);*/

        return (
            tipo &&
            (tipo === "1" || transicion) &&
            (condicion &&
                condicion.length > 0 &&
                condicion.reduce((result, item) => { result = result && this.isOkCondition(item); return result }, true)) &&
            accion &&
            accion.filter((i) => !tipo || i.tipo.toString() === tipo.toString()).length > 0 &&
            accion.filter((i) => !tipo || i.tipo.toString() === tipo.toString()).reduce((result, item) => { result = result && this.isOkAction(item); return result }, true) &&
            nombre
        );
    };

    handleAddAction = () => {
        this.props.onAddAction({
            tipo: 2,
            parametros: {}
        });
    };

    handleAddCondition = () => {
        this.props.onAddCondition({
            tipo: undefined,
            parametros: {}
        });
    }

    handleChangeCondition = (field, index, value, child) => {
        const { condicion } = this.state;
        if (child) {
            condicion[index][field][child] = value;
        } else {
            condicion[index][field] = value;
        }
        this.props.onChange("condicion", condicion);
        this.setState({ condicion: condicion });
    };

    handleChangeAction = (field, index, value, child) => {
        const { accion, tipo } = this.state;
        const arr = accion.filter((i) => !tipo || i.tipo.toString() === tipo.toString());
        if (child) {
            arr[index][field][child] = value;
        } else {
            arr[index][field] = value;
        }
        this.props.onChange("accion", arr);
        this.setState({ accion: arr });
    };

    handleSubmit = () => {
        const { yo, condicion, accion, nombre, tipo, transicion } = this.state;
        const rule = this.props.rule;
        rule.condicion = condicion.map((c) => {
            return c.parametros && c.parametros.campo
                ? {
                    tipo: parseInt(c.tipo, 10),
                    parametros: {
                        campo: {
                            codigo: c.parametros.campo.codigo,
                            nombre: c.parametros.campo.nombre,
                            tipo: c.parametros.campo.tipo,
                            estilo: c.parametros.campo.estilo,
                            catalogo: c.parametros.campo.catalogo,
                            entidad: c.parametros.campo.entidad
                        },
                        valor: c.parametros.valor
                    }
                }
                : {
                    tipo: parseInt(c.tipo, 10),
                    parametros: {}
                }
        });
        rule.accion = accion
            .filter((i) => i.tipo.toString() === tipo.toString())
            .map((c) => {
                if (tipo === "1") {
                    return {
                        tipo: parseInt(c.tipo, 10),
                        parametros: {
                            campo: {
                                codigo: c.parametros.campo.codigo,
                                nombre: c.parametros.campo.nombre,
                                tipo: c.parametros.campo.tipo,
                                estilo: c.parametros.campo.estilo,
                            }
                        }
                    }
                } else {
                    return {
                        tipo: c.tipo,
                        parametros: {
                            tipo: c.parametros.tipo,
                            plantilla: c.parametros.plantilla,
                            familia: c.parametros.familia,
                            proceso: c.parametros.proceso
                        }
                    }
                }
            });
        rule.nombre = nombre;
        rule.tipo = parseInt(tipo, 10);
        rule.yo = parseInt(yo, 10);
        rule.transicion = tipo === "2" ? transicion : undefined;

        this.props.onClose(rule);
    }


    render() {
        const { yo, condicion, accion, nombre, tipo, transicion } = this.state;
        const { intl, templates, families, transitions } = this.props;
        console.log(accion, condicion, transitions);
        return (
            <div className="flex_full_column">
                <div className="flex_auto_column position_sticky bg_white padding_left_36 padding_right_24 padding_bottom_24 padding_top_24 shadow_down_only">
                    <div className="flex_auto_row barlow_semibold c_dark_grey_blue padding_top_12">
                        <BlueCloseIcon
                            className="c_bluish margin_right_32 hand"
                            onClick={() => this.props.onClose(undefined)}
                        />
                        <span className="flex_full_row">
                            <FormattedMessage id="checks_create_rule_title" />
                        </span>
                        {this.isOk() ? (
                            <BlueTickIcon className="c_bluish hand" onClick={this.handleSubmit} />
                        ) : (
                                <BlueTickIcon className="c_disabled" />
                            )}
                    </div>
                    <div>
                        <TextField
                            fullWidth
                            id={'nombre'}
                            name={'nombre'}
                            required
                            onChange={this.handleChange}
                            label={intl.formatMessage({ id: 'local_name' })}
                            className={'flex_full_row'}
                            value={nombre}
                            margin="normal"
                        />
                    </div>
                </div>
                <div className="flex_full_column">
                    <div className="flex_auto_column padding_left_36 padding_right_24 padding_bottom_24 padding_top_24">
                        <Card className={'product_card'}>
                            <CardContent>
                                <Grid container justify="center" className={'flex_grow_1'}>
                                    <Grid item xs={3} className="">
                                        <div className="barlow_regular_small c_slate_grey margin_right_18 text_align_right ">
                                            {intl.formatMessage({ id: 'checks_when_title' })}
                                        </div>
                                    </Grid>
                                    <Grid item xs={9} className="">
                                        <div className="flex_full_column">
                                            <div className="flex_full_row">
                                                <FormControl
                                                    required
                                                    className={
                                                        'flex_full width100 barlow_italic c_slate'
                                                    }
                                                >
                                                    <InputLabel htmlFor="age-native-simple">
                                                        {intl.formatMessage({
                                                            id: 'checks_when_placeholder',
                                                        })}
                                                    </InputLabel>
                                                    <Select
                                                        native
                                                        value={tipo}
                                                        onChange={this.handleChangeType}
                                                        inputProps={{
                                                            name: 'tipo',
                                                            id: 'tipo-simple',
                                                        }}
                                                    >
                                                        <option
                                                            key={randomstring()}
                                                            value={undefined}
                                                        />
                                                        <option
                                                            key={randomstring()}
                                                            value={1}
                                                        >
                                                            {intl.formatMessage({
                                                                id: 'checks_edit',
                                                            })}
                                                        </option>
                                                        <option
                                                            key={randomstring()}
                                                            value={2}
                                                        >
                                                            {intl.formatMessage({
                                                                id: 'checks_transition',
                                                            })}
                                                        </option>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </div>
                    {tipo === "2" &&
                        <div className="flex_auto_column padding_left_36 padding_right_24 padding_bottom_24 padding_top_24">
                            <Card className={'product_card'}>
                                <CardContent>
                                    <Grid container justify="center" className={'flex_grow_1'}>
                                        <Grid item xs={3} className="">
                                            <div className="barlow_regular_small c_slate_grey margin_right_18 text_align_right ">
                                                {intl.formatMessage({ id: 'checks_transicion_title' })}
                                            </div>
                                        </Grid>
                                        <Grid item xs={9} className="">
                                            <div className="flex_full_column">
                                                <div className="flex_full_row">
                                                    <FormControl
                                                        required
                                                        className={
                                                            'flex_full width100 barlow_italic c_slate'
                                                        }
                                                    >
                                                        <InputLabel htmlFor="age-native-simple">
                                                            {intl.formatMessage({
                                                                id: 'checks_transicion_placeholder',
                                                            })}
                                                        </InputLabel>
                                                        <Select
                                                            native
                                                            value={transicion}
                                                            onChange={this.handleChange}
                                                            inputProps={{
                                                                name: 'transicion',
                                                                id: 'transicion-simple',
                                                            }}
                                                        >
                                                            <option
                                                                key={randomstring()}
                                                                value={undefined}
                                                            />
                                                            {transitions &&
                                                                transitions.length > 0 &&
                                                                transitions
                                                                    .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
                                                                    .map((i) =>
                                                                        <option
                                                                            key={randomstring()}
                                                                            value={i.id}
                                                                        >
                                                                            {i.nombre}
                                                                        </option>
                                                                    )
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </div>
                    }
                    <div className="flex_full_row align_center padding_left_36 padding_right_24 padding_bottom_12 margin_bottom_24">
                        <Contidition className="c_bluish margin_right_12" />
                        <div className="barlow_regular_small c_slate_grey margin_left_18 margin_right_18 text_align_right ">
                            {intl.formatMessage({ id: 'checks_condition_title' })}
                        </div>
                        {condicion && condicion.length > 1 && (
                            <div className="flex_full_row align_center elements_from_right">
                                <Radio
                                    checked={yo === '1'}
                                    onChange={this.handleChange}
                                    value={'1'}
                                    name="yo"
                                />
                                <div className="barlow_regular_small c_slate_grey margin_left_6 margin_right_6 text_align_right ">
                                    {intl.formatMessage({ id: 'checks_condition_all' })}
                                </div>
                                <Radio
                                    checked={yo === '2'}
                                    onChange={this.handleChange}
                                    value={'2'}
                                    name="yo"
                                />
                                <div className="barlow_regular_small c_slate_grey margin_left_6 text_align_right ">
                                    {intl.formatMessage({ id: 'checks_condition_any' })}
                                </div>
                            </div>
                        )}
                    </div>
                    {condicion &&
                        condicion.length > 0 &&
                        condicion.map((c, index) => {
                            const { parametros } = c;
                            if (parametros) {
                                return (
                                    <div
                                        key={randomstring()}
                                        className="flex_auto_column padding_left_36 padding_right_24 padding_bottom_24"
                                    >
                                        <Fab
                                            size="small"
                                            color="secondary"
                                            aria-label="Delete"
                                            className="trashFabButton"
                                            onClick={(e) => {
                                                this.props.onDeleteCondition(index);
                                            }}
                                        >
                                            <TrashIcon />
                                        </Fab>
                                        <Condition
                                            {...this.props}
                                            icon={parametros.campo ? getIcon(parametros.campo.tipo, parametros.campo.estilo) : <div />}
                                            campo={c}
                                            index={index}
                                            handleChangeCondition={this.handleChangeCondition}
                                            getIcon={getIcon}
                                        />
                                    </div>
                                );
                            } else {
                                return (<div
                                    key={randomstring()}
                                />);
                            }
                        })}
                    {(!condicion || condicion.length === 0) && (
                        <div className="flex_auto_column padding_left_36 padding_right_24 padding_bottom_24">
                            <Card className={'product_card bg_lipstickligth'}>
                                <CardContent>
                                    <div className="barlow_regular_small c_slate">
                                        <div className="upper">{intl.formatMessage({ id: 'checks_if_alert' })}</div>
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    )}
                    {tipo && tipo !== "1" && (
                        <div className="flex_auto_column padding_left_36 padding_right_24 padding_bottom_24">
                            <ButtonAdd
                                id={'checks_add_codition_button'}
                                handleClick={this.handleAddCondition}
                            />
                        </div>
                    )}
                    <div className="flex_full_row align_center padding_left_36 padding_right_24 padding_bottom_12">
                        <Accion className="c_slate_grey margin_right_12" />
                        <div className="barlow_regular_small c_slate_grey margin_left_18 margin_right_18 text_align_right ">
                            {intl.formatMessage({ id: 'checks_action_title' })}
                        </div>
                    </div>
                    {accion &&
                        accion.length > 0 &&
                        accion.filter((i) => !tipo || i.tipo.toString() === tipo.toString()).map((a, index) => (
                            <div
                                key={randomstring()}
                                className="flex_auto_column padding_left_36 padding_right_24 padding_bottom_24"
                            >
                                <Fab
                                    size="small"
                                    color="secondary"
                                    aria-label="Delete"
                                    className="trashFabButton"
                                    onClick={(e) => {
                                        this.props.onDeleteAction(index);
                                    }}
                                >
                                    <TrashIcon />
                                </Fab>
                                <Action
                                    {...this.props}
                                    action={a}
                                    templates={templates}
                                    index={index}
                                    families={families}
                                    getIcon={getIcon}
                                    handleChangeAction={this.handleChangeAction}
                                />
                            </div>
                        ))}
                    {(!accion || accion.filter((i) => !tipo || i.tipo.toString() === tipo.toString()).length === 0) && (
                        <div className="flex_auto_column padding_left_36 padding_right_24 padding_bottom_24">
                            <Card className={'product_card bg_lipstickligth'}>
                                <CardContent>
                                    <div className="barlow_regular_small c_slate upper">
                                        {intl.formatMessage({ id: 'checks_then_alert' })}
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    )}
                    {tipo && tipo !== "1" && (
                        <div className="flex_auto_column padding_left_36 padding_right_24 padding_bottom_24">
                            <ButtonAdd
                                id={'checks_add_action_button'}
                                handleClick={this.handleAddAction}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default EditRules;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/EditRules.js